var messages = {
  okText: '完了',
  cancelText: 'キャンセル'
};
export default messages;